import type { TOC } from '@ember/component/template-only';

interface GeneralSmartInsightsDetailViewSmartInsightKpiDeltaSignature {
  Args: {
    formatted?: string;
  };
  Element: HTMLSpanElement;
}

// The sign is part of the formatted text so the meaning never relies on colour alone.
export function deltaColorClass(value: number | null | undefined): string {
  if (!value) {
    return 'text-neutral-subdued';
  }

  return value > 0 ? 'text-success-default' : 'text-critical-default';
}

<template>
  <span class="text-200--regular text-neutral-default" ...attributes>
    {{@formatted}}
  </span>
</template> satisfies TOC<GeneralSmartInsightsDetailViewSmartInsightKpiDeltaSignature>;
